import React from 'react';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useBonusRevenueTypes, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const BonusRevenueTypesPage = () => (
  <DynamicCrudPage
    entityType="bonusRevenueTypes"
    hook={useBonusRevenueTypes}
    additionalHooks={{ companies: useCompanies }}
    addButtonTextKey="bonusRevenueTypes.actions.add"
    addButtonIcon={<AddIcon />}
    entityTypeForDataTable="bonusRevenueTypes"
  />
);

export default BonusRevenueTypesPage;
